/**
 * usePreference — 用户偏好持久化
 * V1 简单方案：使用 localStorage（非敏感数据）
 * V1.1 迁移到 ipcCall('cache_set') Rust SQLite 存储
 *
 * 使用方式：
 *   import { getPreference, setPreference } from '@/composables/usePreference'
 *   const collapsed = getPreference<boolean>('sidebar_collapsed')
 *   setPreference('sidebar_collapsed', true)
 */

const PREFERENCE_PREFIX = 'pref:'

/** 获取偏好值 */
export function getPreference<T = unknown>(key: string): T | null {
  try {
    const raw = localStorage.getItem(PREFERENCE_PREFIX + key)
    if (raw === null) return null
    return JSON.parse(raw) as T
  } catch {
    return null
  }
}

/** 设置偏好值 */
export function setPreference(key: string, value: unknown): void {
  try {
    localStorage.setItem(PREFERENCE_PREFIX + key, JSON.stringify(value))
  } catch {
    // localStorage 写入失败静默忽略
  }
}

/** 删除偏好值 */
export function removePreference(key: string): void {
  localStorage.removeItem(PREFERENCE_PREFIX + key)
}
